import { addToListModalStyles as styles } from "@insite/content-library/Components/AddToListModal";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.descriptionText = {
    ...styles.descriptionText,
    variant: "p",
    css: css`
        margin-bottom: 0;
    `,
};
